var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isIE
    ? _c(
        "div",
        { staticClass: "jade pagarme", attrs: { id: "app" } },
        [
          _vm.blockAccess ? _c("delinquent") : _vm._e(),
          _c("global-loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading && !_vm.hasError && !_vm.blockAccess,
                expression: "isLoading && !hasError && !blockAccess",
              },
            ],
          }),
          !_vm.isLoading && _vm.hasError && !_vm.blockAccess
            ? _c(
                "div",
                { staticClass: "stone-rebrand-error" },
                [
                  _c("logo-stone-rebrand", {
                    staticClass: "stone-rebrand-error__logo",
                  }),
                  _c("global-error", {
                    attrs: {
                      showLogo: false,
                      code: _vm.errorCode,
                      theme: _vm.theme,
                    },
                  }),
                ],
                1
              )
            : !_vm.isLoading && !_vm.hasError && !_vm.blockAccess
            ? [
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [_c("router-view")],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }